import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noOnlySpacesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && value.trim().length === 0) {
      return { onlySpaces: true };
    }
    return null;
  };
}

export function noOnlySpecialCharsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || typeof value !== 'string' || value.trim() === '') return null;

    const cleaned = value.replace(/\s+/g, '');
    const hasLetterOrDigit = /\p{L}|\p{N}/u.test(cleaned);

    return hasLetterOrDigit ? null : { onlySpecialChars: true };
  };
}

export function noOnlySpecialCharsAlphaValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || typeof value !== 'string' || value.trim() === '') return null;

    const cleaned = value.replace(/\s+/g, '');
    const hasUnicodeLetter = /\p{L}/u.test(cleaned);

    return hasUnicodeLetter ? null : { onlySpecialAlphaChars: true };
  };
}

export function numbersOnlyDecimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') return null;

    const stringValue = String(value);
    const validNumberPattern = /^\d*\.?\d+$/;
    if (!validNumberPattern.test(stringValue)) {
      return { numbersOnlywithDecimal: true };
    }

    return null;
  };
}

export function numbersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') return null;

    const stringValue = String(value);
    const validNumberPattern = /^\d+$/; // Only digits, no decimals

    if (!validNumberPattern.test(stringValue)) {
      return { numbersOnly: true };
    }

    return null;
  };
}


export function numericValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value;
    if (rawValue === null || rawValue === '') {
      return null; // Let 'required' handle emptiness
    }
    const numericValue = parseFloat(rawValue);
    if (isNaN(numericValue)) {
      return { numbersOnly: true };
    }
    if (numericValue < min) {
      return { min: { min, actual: numericValue } };
    }
    if (numericValue > max) {
      return { max: { max, actual: numericValue } };
    }
    return null;
  };
}
